<template>
	<div>
		<div v-if="models">
			<div>
				<div v-for="(model, index) in models" :key="index" class="flex tr">
					<div class="flex w-full space-x-4">
						<BaseCheckbox v-if="isCheckable" v-model="model.checked" />
						<BaseInput
							:disabled="true"
							:value="model.wmi.length < 3 ? null : manufacturers[model.wmi] || model.manufacturer.name"
							class="w-1/4"
							:title="model.manufacturer.name"
						/>
						<BaseInput
							:ref="'BaseInput.unchecked_wmi' + index"
							:placeholder="$t('wmi')"
							v-model="model.wmi"
							class="w-24"
							mask="BBB"
							@input="
								model.checked = true;
								updateManufacturer(model);
							"
							:required="true"
							:error-message="$t('required_value')"
						/>
						<BaseInput
							:ref="'BaseInput.unchecked_vds' + index"
							:placeholder="$t('vds')"
							v-model="model.vds"
							class="w-24"
							mask="BBBBBB"
							@input="model.checked = true"
							:required="true"
							:error-message="$t('required_value')"
						/>
						<BaseInput
							:ref="'BaseInput.unchecked_name' + index"
							:placeholder="$t('name')"
							v-model="model.name"
							class="flex-grow"
							mask="CXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
							@input="model.checked = true"
							:required="true"
							:error-message="$t('required_value')"
						/>

						<div class="ml-4 flex items-center justify-center h-full pb-4">
							<button
								@click="$router.push({ name: 'vehicles.model.id', params: { id: model.id } })"
								:title="$t('edit_model')"
								class="bg-connectProBlue text-white px-2 py-1 rounded"
							>
								<font-awesome-icon :icon="['fas', 'edit']" />
							</button>
						</div>

						<div class="flex items-center justify-center h-full pb-4">
							<button @click="deleteModel(index, model)" :title="$t('delete_model')" class="bg-connectProBlue text-white px-2 py-1 rounded">
								<font-awesome-icon :icon="['fas', 'trash']" />
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="text-center flex justify-end space-x-4">
			<BaseButton @click="selectAll">{{ $t('choose_all') }}</BaseButton>
			<BaseButton @click="deselectAll">{{ $t('remove_all') }}</BaseButton>
			<BaseButton @click="save" class="btn-blue" tabindex="10000">{{ $t('copy_to_total_list') }}</BaseButton>
		</div>
	</div>
</template>
<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox';
import Validate from '@/mixins/Validate';
import VehicleManufacturerRepository from '@/api/repositories/VehicleManufacturerRepository';

export default {
	name: 'VehicleModelsForm',
	components: { BaseCheckbox, BaseButton, BaseInput },
	mixins: [Validate],
	props: {
		models: {},
		isCheckable: { type: Boolean },
	},
	data() {
		return {
			newModel: {
				id: null,
				wmi: null,
				vds: null,
				model: null,
				checked: true,
			},
			manufacturers: {},
		};
	},
	computed: {
		isModelsTypeAll() {
			return this.$route.name === 'vehicles.models';
		},
	},
	methods: {
		updateManufacturer(model) {
			const wmi = model.wmi;
			if (wmi.length < 3 || this.manufacturers[model.wmi]) return;
			VehicleManufacturerRepository.index({ wmi }).then(response => {
				this.$set(this.manufacturers, model.wmi, response.data.data[0]?.name ?? null);
			});
		},
		deselectAll() {
			this.models.forEach(model => {
				this.$set(model, 'checked', false);
			});
		},
		selectAll() {
			this.models.forEach(model => {
				this.$set(model, 'checked', true);
			});
		},
		save() {
			if (!this.validate()) {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				return;
			}
			if (this.newModel.wmi && !this.isModelsTypeAll) {
				this.models.push(this.newModel);
			}
			this.newModel = {
				id: null,
				wmi: null,
				vds: null,
				model: null,
				checked: true,
			};
			const checked = this.models.filter(model => model.checked);

			if (checked.length > 0) {
				this.$emit('save', checked);
			} else {
				this.$swal(
					this.$t('general.attention').toString(),
					this.$t('please_choose_at_least_one', { variable: 'ein Modell' }).toString(),
					'warning',
				);
			}
		},
		deleteModel(index, model) {
			this.$swal({
				title: this.$t('sure').toString(),
				text: this.$t('delete_model_prompt').toString(),
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: this.$t('general.yes').toString(),
				cancelButtonText: this.$t('general.no').toString(),
			}).then(result => {
				if (result.value) {
					this.$emit('delete', model.id);
					this.models.splice(index, 1);
				}
			});
		},
	},
};
</script>
